/* eslint-disable immutable/no-mutation */

import { useAppContext } from '@contexts/app';
import { usePanel } from '@hooks/usePanel';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';
import { localStore } from '@utils/localStore';
import { useLocation } from 'react-router';
import { Loader } from '@components/loader';
import { ProtectedRouteProps } from './types';

export const ProtectedRoute = ({ children, panel }: ProtectedRouteProps) => {
  const {
    isLogged,
    isResolvingAuth,
    menuAccess: userMenuAccess,
    admin: {
      isLogged: isAdminLogged,
      data: { menuAccess: adminMenuAccess },
    },
  } = useAppContext();

  const { parseUrl } = usePanel();
  const { pathname } = useLocation();

  if (isResolvingAuth) return <Loader />;

  const user = isLogged || Boolean(localStore.getItem('app-user'));
  const admin = isAdminLogged || Boolean(localStore.getItem('app-admin'));
  const menuAccess = !user && admin ? adminMenuAccess : userMenuAccess;

  const redirectToLogin = () => {
    window.location.href = `/${parseRoute(parseUrl(appRoutes.index))}`;
    return null;
  };

  if (panel) {
    if (admin) return children;
    return redirectToLogin();
  }
  if (!user) return redirectToLogin();
  if (menuAccess.length && !menuAccess.some((tab) => pathname.includes(tab)))
    return redirectToLogin();
  return children;
};
